module.exports = __webpack_public_path__ + "static/img/swHover.484fced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg/swHover.png
// module id = OQzQ
// module chunks = 1